import Vue from 'vue';
import i18n from "../../../i18n";

export default {

  async fetchDprOutputs({ commit }, { pId, vId, pvId }) {
    Vue.$log.debug('loading dpr for', pId, vId);
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '') + '&pvId=' + (pvId || '');
    return Vue.axios.get(Vue.$url("dpr-output" + query))
      .then((rsp) => commit("SET_DPR_OUTPUTS", rsp.data));
  },

  async updateDprOutputs({ commit }, payload) {
    return Vue.axios.put(Vue.$url("dpr-output/" + payload.id), payload)
      .then((rsp) => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'DprOutput', 1: payload.columnName }), { root: true });
        return rsp.data;
      })
  },

  async toggleConfiguration({ commit }, payload) {
    return Vue.axios.put(Vue.$url("dpr-output/" + payload.id + "/toggle-state?visible=" + payload.visible))
      .then((rsp) => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'DprOutputConfiguration', 1: payload.sectionName }), { root: true });
        return rsp.data;
      })
  },
}